// The app's real-time Web Audio contexts that take part in a heal of the page's frozen clock, and
// have not been closed (issue #4116). WebKit on iOS renders all of a page's contexts through one
// output unit, which stops only once none of them runs: on the iPhone (iOS 27.0.1, 2026-10-28) a
// heal that suspended the page's context alone, even for a second, restarted nothing, because the
// context the soundfont was decoded on kept running and with it the unit, while a suspend of every
// context at once, held for a second, did restart it. So the clock watchdog (page_audio_context.ts)
// suspends and resumes every context here with the page's. createAudioContext()
// (client/src/player/instrument.ts) registers each context it makes: the page's, and any other
// real-time context that should take part in heals; a context leaves once it is closed. Nothing
// decodes on a real-time context any more: decodeAudioFile() in instrument.ts decodes on an
// OfflineAudioContext, which has no output and is never registered. The Engineering audio lab's
// context is deliberately outside (audio_lab_engine.ts): it captures the microphone, and a heal must
// not stop a recording.

const liveContexts = new Set<AudioContext>();

export function registerAudioContext(context: AudioContext) {
  if (context.state === 'closed') {
    return;
  }
  liveContexts.add(context);
  context.addEventListener('statechange', () => {
    if (context.state === 'closed') {
      liveContexts.delete(context);
    }
  });
}

// In the order they were created
export function liveAudioContexts(): AudioContext[] {
  return [...liveContexts];
}
